import React from 'react';
import { WizardContent } from '@zillow/zrs-rental-applications';
import RenderStep from '../RenderStep';
import LandingStep from './LandingStep';
import TermsStep from './TermsStep';
import PersonalInfoStep from './PersonalInfoStep';
import ReviewStep from './ReviewStep';
import KiqOnboardingStep from './KiqOnboardingStep';
import KiqStep from './KiqStep';
import ErrorStep from './ErrorStep';
import { useNotifyOnStepChange } from './Content.utils';
import { IdvStep } from '../../../models';
import {
  ERROR_STEP_LABEL,
  KIQ_ONBOARDING_STEP_LABEL,
  KIQ_STEP_LABEL,
  LANDING_STEP_LABEL,
  PERSONAL_INFO_STEP_LABEL,
  REVIEW_STEP_LABEL,
  TERMS_STEP_LABEL,
} from '../constants/steps';
import { Box } from '@zillow/constellation-10';

export default function Content() {
  useNotifyOnStepChange();

  return (
    <Box css={{ marginTop: { lg: 'default' }, marginBottom: { base: 'default', lg: 'loose' } }}>
      <WizardContent>
        <RenderStep
          id={IdvStep.LandingStep}
          label={LANDING_STEP_LABEL}
          hidden
          render={() => <LandingStep id={IdvStep.LandingStep} label={LANDING_STEP_LABEL} />}
        />
        <RenderStep
          id={IdvStep.TermsStep}
          label={TERMS_STEP_LABEL}
          render={() => <TermsStep id={IdvStep.TermsStep} label={TERMS_STEP_LABEL} />}
        />
        <RenderStep
          id={IdvStep.PersonalInfoStep}
          label={PERSONAL_INFO_STEP_LABEL}
          render={() => <PersonalInfoStep id={IdvStep.PersonalInfoStep} label={PERSONAL_INFO_STEP_LABEL} />}
        />
        <RenderStep
          id={IdvStep.ReviewStep}
          label={REVIEW_STEP_LABEL}
          render={() => <ReviewStep id={IdvStep.ReviewStep} label={REVIEW_STEP_LABEL} />}
        />
        <RenderStep
          id={IdvStep.KiqOnboardingStep}
          label={KIQ_ONBOARDING_STEP_LABEL}
          hidden
          render={() => <KiqOnboardingStep id={IdvStep.KiqOnboardingStep} label={KIQ_ONBOARDING_STEP_LABEL} />}
        />
        <RenderStep
          id={IdvStep.KiqStep}
          label={KIQ_STEP_LABEL}
          hidden
          render={() => <KiqStep id={IdvStep.KiqStep} label={KIQ_STEP_LABEL} />}
        />
        <RenderStep
          id={IdvStep.ErrorStep}
          label={ERROR_STEP_LABEL}
          hidden
          render={() => <ErrorStep id={IdvStep.ErrorStep} label={ERROR_STEP_LABEL} />}
        />
      </WizardContent>
    </Box>
  );
}
